import { ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';
import { SidePanelSlotsContext, type PanelSide } from './SidePanelSlotsContext';

type PanelAlign = 'center' | 'stretch';

interface SidePanelProps {
    side: PanelSide;
    align?: PanelAlign;
    children: ReactNode;
}

export function SidePanel({
    side,
    align = 'center',
    children,
}: SidePanelProps) {
    const slot = useContext(SidePanelSlotsContext)[side];

    if (!slot) {
        return null;
    }

    const content =
        align === 'center' ? (
            <div className="h-full -mx-1.5 px-1.5 flex flex-col overflow-y-auto overflow-x-hidden scrollbar-grey-600">
                <div className="my-auto py-16">{children}</div>
            </div>
        ) : (
            <div className="h-full min-h-0">{children}</div>
        );

    return createPortal(content, slot);
}
